<template>
  <div class="top-margin">
    <span class="filters-options-text">{{$t('general.sortBy')}}</span>
    <div class="top-margin uk-inline uk-width-1-1 filter-container" @click="select(sortBy)">
      <span class="filter-text-colour uk-form-icon uk-form-icon-flip" uk-icon="icon: chevron-right"></span>
      <button class="uk-button uk-button-default uk-width-1-1 uk-text-left">
        <span class="filter-text-colour" v-if="selectedSortBy">{{selectedSortBy.title}}</span>
      </button>
    </div>
    <div class="top-margin bottom-margin filters-options-text">{{$t('general.narrowResults')}}</div>
    <div v-for="filter in filters">
      <div v-if="filter.title !== 'Strands'" class="filter-container uk-inline uk-width-1-1" @click="select(filter)">
        <span class="filter-text-colour uk-form-icon uk-form-icon-flip" uk-icon="icon: chevron-right"></span>
        <button class="uk-button uk-button-default uk-width-1-1 uk-text-left"><span class="filter-text-colour">{{filterTitle(filter.title)}}</span>
        </button>
      </div>
      <div v-else-if="filter.title === 'Strands' && standardSelected && strandOptions" class="filter-container uk-inline uk-width-1-1" @click="select(filter)">
        <span class="filter-text-colour uk-form-icon uk-form-icon-flip" uk-icon="icon: chevron-right"></span>
        <button class="uk-button uk-button-default uk-width-1-1 uk-text-left"><span class="filter-text-colour">{{filterTitle(filter.title)}}</span>
        </button>
      </div>
    </div>
    <button class="uk-width-1-1 cp-primary-button button-style uk-align-center" @click="onDone">{{$t('general.done')}}
    </button>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
      name: 'MobileFilterMenu',
      props: ['filters', 'sortBy'],
      methods: {
        select(filter) {
          this.$emit('onSelection', filter)
        },
        onDone() {
          this.$emit('close')
        },
        filterTitle(title) {
          switch (title) {
            case 'Grades':
              return (this.defaultLang) ? this.$t('general.grades') : this.$t('general.ages')
            case 'Subjects':
              return this.$t('general.subjects')
            case 'Resource Type':
              return this.$t('general.resourceType')
            case 'Location':
              return this.$t('general.location')
            case 'Standards':
              return this.$t('general.standard')
            case 'Strands':
              return this.$t('general.strands')
          }
        }
      },
      computed: {
        ...mapGetters(['getStandards', 'getSearchStrands']),
        selectedSortBy() {
          return this.sortBy.items.find(f => f.selected)
        },
        defaultLang() {
          return this.$i18n.locale === 'en' || this.$i18n.locale === 'en-US'
        },
        standardSelected() {
          return this.getStandards.find(x => x.selected).id !== 'none'
        },
        strandOptions() {
          return this.getSearchStrands.length > 0
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import '../../../../../src/styles/colours';

  .top-margin {
    margin-top: 11px;
  }

  .bottom-margin {
    margin-bottom: 11px;
  }

  .filter-text-colour {
    color: $content-text;
  }

  .filters-options-text {
    color: $content-text;
    margin-left: 26px;
    font-size: 14px;
    font-weight: bold;
  }

  .filter-container {
    height: 59px;
    background-color: $app-background;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    margin-bottom: 8px;

    &:hover {
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.3);
    }
  }

  .uk-button {
    border: none;
    height: 100%;
    text-transform: none;
  }

  .button-style {
    font-size: 20px;
    font-weight: bold;
    width: 90%;
    height: 48px;
    border-radius: 2px;
  }

</style>
